import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Bookmark, MapPin, BadgeCheck } from "lucide-react";
import { api, resolveFileUrl } from "../api";

export default function BookmarksPage() {
  const [rows, setRows] = useState([]);
  const [busy, setBusy] = useState(true);

  const load = () => {
    setBusy(true);
    api.get("/my/bookmarks").then((r) => setRows(r.data)).finally(() => setBusy(false));
  };
  useEffect(() => { load(); }, []);

  const remove = async (uid) => {
    await api.delete(`/bookmarks/${uid}`);
    setRows((r) => r.filter((u) => u.id !== uid));
  };

  return (
    <div className="max-w-[1400px] mx-auto px-4 sm:px-6 py-16 pb-32" data-testid="bookmarks-page">
      <div className="font-mono-label text-[10px] text-[var(--accent)] mb-3">SAVED FOR LATER</div>
      <h1 className="font-display text-5xl sm:text-6xl uppercase leading-none mb-10">My Bookmarks</h1>

      {busy ? (
        <p className="font-mono-label text-[10px] text-neutral-500">Loading…</p>
      ) : rows.length === 0 ? (
        <div className="border border-dashed border-neutral-800 p-12 text-center" data-testid="bookmarks-empty">
          <Bookmark size={28} className="mx-auto text-neutral-600 mb-4" />
          <p className="font-mono-label text-[11px] text-neutral-500 mb-6">No one bookmarked yet — save creators from their profile to come back later.</p>
          <Link to="/culture-connect" className="btn-primary">Browse Culture Connect</Link>
        </div>
      ) : (
        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-4" data-testid="bookmarks-list">
          {rows.map((u) => (
            <div key={u.id} className="card-brut p-5" data-testid={`bookmark-${u.username}`}>
              <Link to={`/profile/${u.username}`} className="flex items-center gap-3 mb-3">
                {u.avatar ? (
                  <img src={resolveFileUrl(u.avatar)} alt="" className="w-14 h-14 object-cover border border-neutral-800" />
                ) : (
                  <div className="w-14 h-14 border border-neutral-800 bg-neutral-900 flex items-center justify-center font-display text-xl">{u.display_name.slice(0, 2).toUpperCase()}</div>
                )}
                <div className="flex-1 min-w-0">
                  <div className="flex items-center gap-1">
                    <div className="font-headline text-base uppercase truncate">{u.display_name}</div>
                    {u.verified && <BadgeCheck size={13} className="text-[var(--accent)]" />}
                  </div>
                  <div className="font-mono-label text-[10px] text-neutral-500 truncate">{u.service_title || `@${u.username}`}</div>
                </div>
              </Link>
              <div className="flex flex-wrap gap-2 mb-3">
                {u.account_type && <span className="chip">{u.account_type.toUpperCase()}</span>}
                {(u.city || u.state) && <span className="chip inline-flex items-center gap-1"><MapPin size={10} /> {[u.city, u.state].filter(Boolean).join(", ").toUpperCase()}</span>}
                {u.rate_amount > 0 && <span className="chip chip-accent">${u.rate_amount}/{u.rate_unit || "hr"}</span>}
              </div>
              <div className="flex gap-2">
                <Link to={`/profile/${u.username}`} className="btn-primary flex-1 justify-center text-[11px]">View Profile</Link>
                <button onClick={() => remove(u.id)} className="btn-ghost text-[11px]" data-testid={`unbookmark-${u.username}`}>Remove</button>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
